import { memo, useEffect, useState } from 'react';

import { Button } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  title?: string;
  action?: () => void;
}

const Addon: React.FC<Props> = ({ title, action, children }) => {
  const classes = useStyles();
  const [maxHeight, setMaxHeight] = useState<string | number>('auto');

  // useEffect(() => {
  //   let mh = 0;
  //   document.querySelectorAll('.addonWrapper').forEach((addon) => {
  //     let addonHeight = addon.getBoundingClientRect().height;

  //     if (addonHeight > mh) {
  //       mh = addonHeight;
  //     }
  //   });

  //   setMaxHeight(mh || 'auto');
  // }, []);

  return (
    <div className={classes.root}>
      <div
        className={clsx('addonWrapper', classes.addonWrapper)}
        style={{ height: maxHeight }}
      >
        {children}
      </div>
      <div className={classes.addonTitleWrapper}>
        {title ? <p className={classes.addonTitle}>{title}</p> : null}
        {action ? (
          <Button className={classes.btn} onClick={action}>
            <ChevronRightIcon className={classes.icon} />
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default memo(Addon);
